/**
 * 从 Content-Disposition 解析下载文件名。
 * 优先处理 RFC 5987 的 filename*=UTF-8''percent-encoded，避免中文名乱码。
 */
export function parseFilenameFromContentDisposition(
  contentDisposition: string | null | undefined,
): string {
  if (!contentDisposition) {
    return '';
  }

  const cd = contentDisposition.trim();

  // RFC 5987: filename*=UTF-8''%E4%B8%AD%E6%96%87.xlsx
  const rfc5987Utf8 = /filename\*=\s*(?:UTF-8|utf-8)''([^;\n]+)/i;
  const mUtf8 = rfc5987Utf8.exec(cd);
  if (mUtf8?.[1]) {
    const encoded = mUtf8[1].trim().replace(/^["']|["']$/g, '');
    try {
      return decodeURIComponent(encoded);
    } catch {
      // 非法编码则继续尝试其它规则
    }
  }

  // 其它 charset 的 filename*=charset''value
  const rfc5987Any = /filename\*=\s*[^']*''([^;\n]+)/;
  const mAny = rfc5987Any.exec(cd);
  if (mAny?.[1]) {
    const encoded = mAny[1].trim().replace(/^["']|["']$/g, '');
    try {
      return decodeURIComponent(encoded);
    } catch {
      // continue
    }
  }

  // RFC 2616: filename="..." 或 filename=...
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(cd);
  if (matches?.[1]) {
    let raw = matches[1].replace(/['"]/g, '').trim();
    if (/%[0-9A-Fa-f]{2}/.test(raw)) {
      try {
        return decodeURIComponent(raw);
      } catch {
        // ignore
      }
    }
    return raw;
  }

  return '';
}

export const downloadFile = (url: string, name = '') => {
  const el = document.createElement('a');
  el.setAttribute('href', url);
  el.setAttribute('download', name);
  el.setAttribute('rel', 'noreferrer');
  el.setAttribute('target', '_blank');
  el.style.display = 'none';
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
};